import React from 'react';

import '../../styles/components/DayGraph.css';
import DayGraphLine from './DayGraphLine';

function DayGraph ({ items, day, onEditShift }) {
  const itemsElement = items.length ? items.map((item) => (
    <DayGraphLine
      key={item.id}
      item={item}
      day={day}
      onEdit={() => {
        onEditShift(item);
      }}
    />
  )) : null;

  const timeBar = (
    <div className="DayGraph__Time">
      {[...Array(24).keys()].map((i, hour) => {
        return <div key={hour}>{hour}</div>;
      })}
    </div>
  );

  return (
    <div className="DayGraph">
      {timeBar}
      {itemsElement}
    </div>
  );
}

export default DayGraph;



// WEBPACK FOOTER //
// ./src/components/DayModal/DayGraph.js